module.exports = __webpack_public_path__ + "static/rr-black-787f395eefa931a0c3242c2788ec6749.png";